import { OpusJobsLandingComponent } from './opus-jobs-landing.component';

export const containers: any[] = [OpusJobsLandingComponent];

export * from './opus-jobs-landing.component';
